class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.setPrices();
  }

  setPrices() {
    const regularPrice = this.dataset.regularPrice;
    const salePrice = this.dataset.salePrice;
    const privateSalePrice = this.dataset.privateSalePrice;

    let isCompareAtPrice = false;

    if (salePrice) {
      isCompareAtPrice = true;
    }

    if (
      privateSalePrice &&
      (window.privateSale || window.initialPrivateSaleAccess)
    ) {
      isCompareAtPrice = true;
    }

    const priceHTML = `<span class="prd-Price">
      ${
        isCompareAtPrice ?
          `
        <s class="prd-Price_RegularPrice">
          <span class="util-ScreenReaderOnly">
          </span>
          ${regularPrice}
        </s>
        <span class="prd-Price_SalePrice">
          <span class="util-ScreenReaderOnly">
          </span>
          ${privateSalePrice || salePrice}
        </span>
      `
        : regularPrice
      }
    </span>`;

    this.innerHTML = priceHTML;
  }
}

if (!customElements.get("product-price")) {
  customElements.define("product-price", ProductPrice);
}
